import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInWithEventCodeMutationVariables = Types.Exact<{
  input: Types.SignInWithEventCodeInput;
}>;

export type SignInWithEventCodeMutation = {
  __typename?: 'Mutation';
  signInWithEventCode: {
    __typename?: 'SignInWithEventCodeResponse';
    message: string;
    success: boolean;
    refreshToken: string;
    accessToken: string;
    eventUuid: string;
    organizationUuid: string;
    clientGroupUuid: string;
  };
};

export const SignInWithEventCodeDocument = gql`
  mutation SignInWithEventCode($input: SignInWithEventCodeInput!) {
    signInWithEventCode(input: $input) {
      message
      success
      refreshToken
      accessToken
      eventUuid
      organizationUuid
      clientGroupUuid
    }
  }
`;
export type SignInWithEventCodeMutationFn = Apollo.MutationFunction<
  SignInWithEventCodeMutation,
  SignInWithEventCodeMutationVariables
>;
export function useSignInWithEventCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignInWithEventCodeMutation,
    SignInWithEventCodeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignInWithEventCodeMutation,
    SignInWithEventCodeMutationVariables
  >(SignInWithEventCodeDocument, options);
}
export type SignInWithEventCodeMutationHookResult = ReturnType<
  typeof useSignInWithEventCodeMutation
>;
export type SignInWithEventCodeMutationResult =
  Apollo.MutationResult<SignInWithEventCodeMutation>;
export type SignInWithEventCodeMutationOptions = Apollo.BaseMutationOptions<
  SignInWithEventCodeMutation,
  SignInWithEventCodeMutationVariables
>;
